import { Component, Inject, OnInit, EventEmitter } from '@angular/core'
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-edit-breaks',
  templateUrl: './edit-breaks.component.html',
  styleUrls: ['./edit-breaks.component.scss'],
})
export class EditBreaksComponent implements OnInit {
  addBreaksEventEmitter = new EventEmitter();
  editBreaksEventEmitter = new EventEmitter();
  shiftNumbers: any[] = [];
  shiftNumber: any;
  dayWeek: any;
  startTime: any;
  endTime: any;
  toTime: any;
  fromTime: any;
  errorMessage: any;
  times: string[] = [];
  times2: string[] = [];
  hoursArray = new Array(24);
  mintuesArray = new Array(60);

  addOrEditform: UntypedFormGroup = this.formBuilder.group({
    shiftNumber: [''],
    toHoursHH: ['', Validators.required],
    toMintuesMM: ['', Validators.required],
    fromHoursHH: ['', Validators.required],
    fromMintuesMM: ['', Validators.required],
  },
  );

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<EditBreaksComponent>,
    private readonly formBuilder: UntypedFormBuilder

  ) { }
  get addOrEdit() {
    return this.addOrEditform.controls;
  }
  ngOnInit(): void {
    this.addOrEditform.controls.shiftNumber.setValue(this.data.shift_no);
    if(this.data.mode === 'edit'){

    
    let fromHoursHH: number | undefined, fromMinutesMM: number | undefined;
    let toHoursHH: number | undefined, toMinutesMM: number | undefined;

    if (this.data?.field?.time_from) {
      const [hh, mm] = this.data.field.time_from.split(':').map(Number);
      fromHoursHH = hh;
      fromMinutesMM = mm;
    }

    if (this.data?.field?.time_to) {
      const [hh, mm] = this.data.field.time_to.split(':').map(Number);
      toHoursHH = hh;
      toMinutesMM = mm;
    }

    this.addOrEditform.patchValue({
      fromHoursHH: fromHoursHH,
      fromMintuesMM: fromMinutesMM,
      toHoursHH: toHoursHH,
      toMintuesMM: toMinutesMM,
      shiftNumber: this.addOrEdit.shiftNumber.value
    });
  }
    // Log for debugging
    this.addOrEditform.controls.fromHoursHH.valueChanges.subscribe((hour: number) => {
      if (hour !== null) {
        this.addOrEditform.controls.fromMintuesMM.setValue(0);  // Set minutes to 00
      }
    });
 
    // Listen for changes in the 'toHoursHH' field and set minutes to '00' when hour is selected
    this.addOrEditform.controls.toHoursHH.valueChanges.subscribe((hour: number) => {
      if (hour !== null) {
        this.addOrEditform.controls.toMintuesMM.setValue(0);  // Set minutes to 00
      }
    });

    this.shiftNumbers = [
      { value: 1 },
      { value: 2 },
      { value: 3 }
    ];
  }

  formatNumber(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  submitted: boolean = false;
  convertToFullTimeFormat(time: string): string {
    // Check if the time already includes seconds, if not, add ':00'
    if (time.length === 5) { // The format HH:mm (length 5)
      return `${time}:00`; // Append ':00' to represent seconds
    }
    return time; // If it already includes seconds, return as is
  }


// editRowBreakDetails() {
//     console.log("++",this.data)
//     const shiftStartTime = this.data.field.start_time;  // Format: 'HH:mm:ss'
//     const shiftEndTime = this.data.field.end_time;
  
//     if (this.addOrEditform.invalid) {
//       this.submitted = true;
//       return;
//     }
  
//     const fromHoursHH = this.addOrEditform.get('fromHoursHH')?.value;
//     const fromMintuesMM = this.addOrEditform.get('fromMintuesMM')?.value;
//     const toHoursHH = this.addOrEditform.get('toHoursHH')?.value;
//     const toMintuesMM = this.addOrEditform.get('toMintuesMM')?.value;
  
//     // Construct full time strings (HH:mm:ss)
//     const fromTimeNew = `${fromHoursHH.toString().padStart(2, '0')}:${fromMintuesMM.toString().padStart(2, '0')}:00`;
//     const toTimeNew = `${toHoursHH.toString().padStart(2, '0')}:${toMintuesMM.toString().padStart(2, '0')}:00`;
  
//     // Use today's date just to create valid moment objects
//     const format = 'HH:mm:ss';
//     const breakStart = moment(fromTimeNew, format);
//     const breakEnd = moment(toTimeNew, format);
//     const shiftStart = moment(shiftStartTime, format);
//     const shiftEnd = moment(shiftEndTime, format);
  



//     // Handle overnight shift
// if (shiftEnd.isBefore(shiftStart)) {
//   shiftEnd.add(1, 'day');

//   if (breakStart.isBefore(shiftStart)) {
//     breakStart.add(1, 'day');
//   }
//   if (breakEnd.isBefore(shiftStart)) {
//     breakEnd.add(1, 'day');
//   }
// } else {
//   if (breakEnd.isBefore(breakStart)) {
//     breakEnd.add(1, 'day');
//   }
// }

// // New: Ensure break duration is positive
// if (!breakEnd.isAfter(breakStart)) {
//   this.submitted = true;
//   this.errorMessage = 'Break end time must be after start time.';
//   return;
// }

// // Final validation: Break within shift
// if (breakStart.isBefore(shiftStart) || breakEnd.isAfter(shiftEnd)) {
//   this.submitted = true;
//   this.errorMessage = 'Break must be within shift time.';
//   return;
// }

  
//     // Final validation
//     if (breakStart.isBefore(shiftStart) || breakEnd.isAfter(shiftEnd)) {
//       this.submitted = true;
//       this.errorMessage = 'Break must be within shift time.';
//       return;
//     }
  
//     const editEmittedData = {
//       shiftNumber: this.addOrEdit.shiftNumber.value,
//       toHoursHH,
//       toMintuesMM,
//       fromHoursHH,
//       fromMintuesMM,
//       fromTimeNew,
//       toTimeNew,
//     };
  
//     this.editBreaksEventEmitter.emit(editEmittedData);
//     this.dialogRef.close();
//   }
  

// break conflict logic
editRowBreakDetails() {
  const shiftStartTime = this.data.field.start_time; // Format: 'HH:mm:ss'
  const shiftEndTime = this.data.field.end_time;
  const currentBreakId = this.data.field.break_id; // Assuming each break has unique id

  if (this.addOrEditform.invalid) {
    this.submitted = true;
    return;
  }

  const fromHoursHH = this.addOrEditform.get('fromHoursHH')?.value;
  const fromMintuesMM = this.addOrEditform.get('fromMintuesMM')?.value;
  const toHoursHH = this.addOrEditform.get('toHoursHH')?.value;
  const toMintuesMM = this.addOrEditform.get('toMintuesMM')?.value;

  const fromTimeNew = `${fromHoursHH.toString().padStart(2, '0')}:${fromMintuesMM.toString().padStart(2, '0')}:00`;
  const toTimeNew = `${toHoursHH.toString().padStart(2, '0')}:${toMintuesMM.toString().padStart(2, '0')}:00`;

  const format = 'HH:mm:ss';
  let breakStart = moment(fromTimeNew, format);
  let breakEnd = moment(toTimeNew, format);
  let shiftStart = moment(shiftStartTime, format);
  let shiftEnd = moment(shiftEndTime, format);

  // Handle overnight shift
  if (shiftEnd.isBefore(shiftStart)) {
    shiftEnd.add(1, 'day');

    if (breakStart.isBefore(shiftStart)) breakStart.add(1, 'day');
    if (breakEnd.isBefore(shiftStart)) breakEnd.add(1, 'day');
  } else {
    if (breakEnd.isBefore(breakStart)) breakEnd.add(1, 'day');
  }

  // Ensure break duration positive
  if (!breakEnd.isAfter(breakStart)) {
    this.submitted = true;
    this.errorMessage = 'Break end time must be after start time.';
    return;
  }

  // Break must be within shift
  if (breakStart.isBefore(shiftStart) || breakEnd.isAfter(shiftEnd)) {
    this.submitted = true;
    this.errorMessage = 'Break must be within shift time.';
    return;
  }


  for (const existingBreak of this.data?.rowData ?? []){    
    // Skip checking against the break we are editing
    if (existingBreak.break_id === currentBreakId) continue;

    let existingBreakStart = moment(existingBreak.time_from, format);
    let existingBreakEnd = moment(existingBreak.time_to, format);

    // Handle overnight break crossing midnight for existing breaks
    if (existingBreakEnd.isBefore(existingBreakStart)) {
      existingBreakEnd.add(1, 'day');
    }

    // Adjust existing break times relative to shift, if needed
    // (If your shifts can be overnight, might need to align day like for new break)
    if (shiftEnd.isBefore(shiftStart)) {
      if (existingBreakStart.isBefore(shiftStart)) existingBreakStart.add(1, 'day');
      if (existingBreakEnd.isBefore(shiftStart)) existingBreakEnd.add(1, 'day');
    }

    // Check overlap condition:
    // Overlap if new break starts before existing break ends AND new break ends after existing break starts
    const isOverlap = breakStart.isBefore(existingBreakEnd) && breakEnd.isAfter(existingBreakStart);
    if (isOverlap) {
      this.submitted = true;
      this.errorMessage = `Break conflicts with an existing break from ${existingBreak.time_from} to ${existingBreak.time_to}.`;
      return;
    }
  }

  // If no overlaps, emit the data
  const editEmittedData = {
    shiftNumber: this.addOrEdit.shiftNumber.value,
    toHoursHH,
    toMintuesMM,
    fromHoursHH,
    fromMintuesMM,
    fromTimeNew,
    toTimeNew,
  };

  this.editBreaksEventEmitter.emit(editEmittedData);
  this.dialogRef.close();
}

  
  callRespectiveFunction() {
    if (this.data?.mode === 'edit') {
      this.editRowBreakDetails();
    } else {
      this.addBreakDetails();
    }
  }
  // add break validation corrected
  // addBreakDetails() {
  //   this.addOrEditform.controls.shiftNumber.setValue(this.data.shift_no);
  
  //   const shiftStartTime = this.data.startTime;  // Format: HH:mm
  //   const shiftEndTime = this.data.endTime;
  
  //   if (!this.addOrEditform.valid) {
  //     this.submitted = true;
  //     return;
  //   }
  
  //   const { toHoursHH, toMintuesMM, fromHoursHH, fromMintuesMM } = this.addOrEditform.value;
  
  //   const toTimeNew = `${toHoursHH.toString().padStart(2, '0')}:${toMintuesMM.toString().padStart(2, '0')}:00`;
  //   const fromTimeNew = `${fromHoursHH.toString().padStart(2, '0')}:${fromMintuesMM.toString().padStart(2, '0')}:00`;
  
  //   const format = 'HH:mm:ss';
  
  //   const shiftStart = moment(shiftStartTime, format);
  //   const shiftEnd = moment(shiftEndTime, format);
  //   const breakStart = moment(fromTimeNew, format);
  //   const breakEnd = moment(toTimeNew, format);
  
  //   // Handle overnight shift
  //   if (shiftEnd.isBefore(shiftStart)) {
  //     shiftEnd.add(1, 'day');
  
  //     if (breakStart.isBefore(shiftStart)) {
  //       breakStart.add(1, 'day');
  //     }
  //     if (breakEnd.isBefore(shiftStart)) {
  //       breakEnd.add(1, 'day');
  //     }
  //   } else {
  //     if (breakEnd.isBefore(breakStart)) {
  //       breakEnd.add(1, 'day');
  //     }
  //   }
  
  //   //  Validate break start < break end
  //   if (!breakEnd.isAfter(breakStart)) {
  //     this.submitted = true;
  //     this.errorMessage = 'Break end time must be after start time.';
  //     return;
  //   }
  
  //   // Validate break is within shift
  //   if (breakStart.isBefore(shiftStart) || breakEnd.isAfter(shiftEnd)) {
  //     this.submitted = true;
  //     this.errorMessage = 'Break must be within shift time.';
  //     return;
  //   }
  
  //   const addEmittedData = {
  //     shiftNumber: this.addOrEdit.shiftNumber.value,
  //     fromTimeNew,
  //     toTimeNew,
  //   };
  
  //   this.addBreaksEventEmitter.emit(addEmittedData);
  //   this.dialogRef.close();
  // }
  
  // Break conflict added
  addBreakDetails() {
    this.addOrEditform.controls.shiftNumber.setValue(this.data.shift_no);
  
    const shiftStartTime = this.data.startTime;  // Format: HH:mm:ss or HH:mm
    const shiftEndTime = this.data.endTime;
  
    if (!this.addOrEditform.valid) {
      this.submitted = true;
      return;
    }
  
    const { toHoursHH, toMintuesMM, fromHoursHH, fromMintuesMM } = this.addOrEditform.value;
  
    const toTimeNew = `${toHoursHH.toString().padStart(2, '0')}:${toMintuesMM.toString().padStart(2, '0')}:00`;
    const fromTimeNew = `${fromHoursHH.toString().padStart(2, '0')}:${fromMintuesMM.toString().padStart(2, '0')}:00`;
  
    const format = 'HH:mm:ss';
  
    let shiftStart = moment(shiftStartTime, format);
    let shiftEnd = moment(shiftEndTime, format);
    let breakStart = moment(fromTimeNew, format);
    let breakEnd = moment(toTimeNew, format);
  
    // Handle overnight shift
    if (shiftEnd.isBefore(shiftStart)) {
      shiftEnd.add(1, 'day');
  
      if (breakStart.isBefore(shiftStart)) {
        breakStart.add(1, 'day');
      }
      if (breakEnd.isBefore(shiftStart)) {
        breakEnd.add(1, 'day');
      }
    } else {
      if (breakEnd.isBefore(breakStart)) {
        breakEnd.add(1, 'day');
      }
    }
  
    // Validate break start < break end
    if (!breakEnd.isAfter(breakStart)) {
      this.submitted = true;
      this.errorMessage = 'Break end time must be after start time.';
      return;
    }
  
    // Validate break is within shift
    if (breakStart.isBefore(shiftStart) || breakEnd.isAfter(shiftEnd)) {
      this.submitted = true;
      this.errorMessage = 'Break must be within shift time.';
      return;
    }
  
    // --- New validation: Check overlap with existing breaks ---
    for (const existingBreak of this.data?.rowData ?? []){
            // For adding, no need to skip any break because it's new
  
      let existingBreakStart = moment(existingBreak.time_from, format);
      let existingBreakEnd = moment(existingBreak.time_to, format);
  
      // Handle overnight existing breaks
      if (existingBreakEnd.isBefore(existingBreakStart)) {
        existingBreakEnd.add(1, 'day');
      }
  
      // Handle overnight shift adjustments for existing breaks
      if (shiftEnd.isBefore(shiftStart)) {
        if (existingBreakStart.isBefore(shiftStart)) existingBreakStart.add(1, 'day');
        if (existingBreakEnd.isBefore(shiftStart)) existingBreakEnd.add(1, 'day');
      }
  
      const isOverlap = breakStart.isBefore(existingBreakEnd) && breakEnd.isAfter(existingBreakStart);
      if (isOverlap) {
        this.submitted = true;
        this.errorMessage = `Break conflicts with an existing break from ${existingBreak.time_from} to ${existingBreak.time_to}.`;
        return;
      }
    }
  
    const addEmittedData = {
      shiftNumber: this.addOrEdit.shiftNumber.value,
      fromTimeNew,
      toTimeNew,
    };
  
    this.addBreaksEventEmitter.emit(addEmittedData);
    this.dialogRef.close();
  }
  

}